<template>
  <v-card
    :height="widgetHeight"
    :min-width="widgetWidth"
    :color="settingsModel.color"
    class="ma-0 pa-0"

  >
    <v-card-title class="pa-0 ma-0">
      <v-col cols="12" sm="3" justify="left" class="pa-0 ma-0">
        <v-icon class="ml-1" :color="settingsModel.textColor"
          >mdi-pencil-box-outline</v-icon
        >
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" class="pa-0 ma-0" align="center" justify="center">
        <h3>
          <span :style="{ color: settingsModel.textColor }">{{
            settingsModel.widgetTitle
          }}</span>
        </h3>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="3" class="pa-0 ma-0 d-flex flex-row-reverse">
        <div style="height: 30px">
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                :color="settingsModel.textColor"
                @click.prevent="showSettings"
                >mdi-cog</v-icon
              >
            </template>
            <span>{{ $t("Settings") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                :color="settingsModel.textColor"
                @click.prevent="removeWidget"
                >mdi-delete</v-icon
              >
            </template>
            <span>{{ $t("Delete") }}</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-card-title>
    <v-card-text
      class="pa-0 ma-0"
      :style="`height: ${contentHeight}px;max-height: ${contentHeight}px`"
    >
      <div class="overflow-y-auto">
        <v-textarea
          v-if="!settingsModel.checkBoxes"
          :id="'wn' + id"
          solo
          flat
          no-resize
          :height="contentHeight"
          :background-color="settingsModel.color"
          v-model="text"
          @focusout="saveData"
          :style="`color: ${settingsModel.textColor}`"
        ></v-textarea>
        <v-list
          shaped
          v-if="settingsModel.checkBoxes"
          :color="settingsModel.color"
          class="ma-0 pa-0 overflow-y-auto"
          :style="`height: ${widgetHeight - headerHeight}px;max-height: ${
            widgetHeight - headerHeight
          }px`"
        >
          <v-list-item style="min-height: 10px">
            <v-text-field
              @keydown.enter="addTask"
              autocomplete="username"
              autofocus
              :color="settingsModel.textColor"
              clearable
              :placeholder="$t('Add')"
              v-model="newTask"
              class="py-0 my-0 mx-2"
            >
              <v-icon slot="prepend" :color="settingsModel.textColor">
                mdi-file-plus
              </v-icon>
            </v-text-field>
          </v-list-item>
          <v-list-item style="min-height: 10px">
            <v-spacer></v-spacer>
            <v-row justify="center" class="ml-2">
              <v-btn
                :text="visibility != 'all'"
                class="mx-0"
                small
                :color="settingsModel.textColor"
                @click="visibility = 'all'"
              >
                {{ $t("All") }}
              </v-btn>
              <v-btn
                :text="visibility != 'active'"
                class="mx-0"
                small
                :color="settingsModel.textColor"
                @click="visibility = 'active'"
              >
                {{ $t("Active") }}
              </v-btn>
              <v-btn
                :text="visibility != 'completed'"
                class="mx-0"
                small
                :color="settingsModel.textColor"
                @click="visibility = 'completed'"
              >
                {{ $t("Completed") }}
              </v-btn>
            </v-row>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="clearTasks"
                  icon
                  :color="settingsModel.textColor"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>{{ $t("DeleteAll") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  class="ml-2"
                  icon
                  @click="clearCompletedTasks"
                  :color="settingsModel.textColor"
                >
                  mdi-delete-forever
                </v-icon>
              </template>
              <span>{{ $t("DeleteCompleted") }}</span>
            </v-tooltip>
          </v-list-item>
          <template v-for="(task, i) in filteredTask">
            <v-hover v-slot:default="{ hover }" :key="`${i}-${task.text}`">
              <v-list-item style="min-height: 30px">
                <v-list-item-action class="mr-2">
                  <v-checkbox
                    v-model="task.done"
                    :color="settingsModel.textColor"
                    v-if="!task.editing"
                    @change="saveData"
                  >
                  </v-checkbox>
                  <v-icon :color="settingsModel.textColor" v-else
                    >mdi-pencil</v-icon
                  >
                </v-list-item-action>
                <v-list-item-content class="ma-0 pa-0">
                  <span
                    :class="task.done && 'text-decoration-line-through'"
                    :style="`color: ${settingsModel.textColor}`"
                    v-text="task.text"
                    v-if="!task.editing"
                  ></span>
                  <v-text-field
                    :value="task.text"
                    @blur="doneEdit($event, i)"
                    @keyup.enter="doneEdit($event, i)"
                    @keyup.esc="task.editing = false"
                    full-width
                    :style="`color: ${settingsModel.textColor}`"
                    :color="settingsModel.textColor"
                    :ref="`taskInput${i}`"
                    dense
                    v-else
                  ></v-text-field>
                </v-list-item-content>

                <v-icon
                  v-if="hover && !task.editing"
                  :color="settingsModel.textColor"
                  @click="editTask(i)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  v-if="hover && !task.editing"
                  :color="settingsModel.textColor"
                  class="ml-2"
                  @click="remove(i)"
                >
                  mdi-delete
                </v-icon>
              </v-list-item>
            </v-hover>
          </template>
        </v-list>
      </div>
      <SettingsModal :ref="modalKey" @on-save="onSettingsSave" />
    </v-card-text>
  </v-card>
</template>

<script>
import WidgetService from "@/services/WidgetService";
import SettingsModal from "@/components/widgets/note/WidgetNoteSettings";
import WidgetSettings from "@/ecm/models/widget/note/WidgetNoteSettings";
import WidgetType from "@/ecm/variables/WidgetType";

export default {
  components: { SettingsModal },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
    settings: { type: Object },
  },
  data() {
    return {
      hover: false,
      headerHeight: 30,
      widgetHeight: 0,
      widgetWidth: 0,
      settingsModel: new WidgetSettings(),
      text: "",
      newTask: "",
      filters: {
        all: () => this.tasks,
        active: () => this.tasks.filter((task) => !task.done),
        completed: () => this.tasks.filter((task) => task.done),
      },
      visibility: "all",
      tasks: [],
      modalKey: "modalSettingsKey",
    };
  },
  mounted() {
    this.widgetHeight = this.height;
    this.widgetWidth = this.width;
    this.settingsModel = new WidgetSettings(this.settings);
    this.loadData();
    var textArea = document.getElementById("wn" + this.id);
    if (textArea) {
      textArea.style.color = this.settingsModel.textColor;
    }
  },
  computed: {
    modalSettings() {
      return this.$refs[this.modalKey];
    },
    contentHeight() {
      return this.widgetHeight - this.headerHeight;
    },
    filteredTask() {
      return this.filters[this.visibility]();
    },
  },
  methods: {
    loadData() {
      let text = this.settingsModel.text;
      if (this.settingsModel.checkBoxes) {
        try {
          let isArray =
            text.includes("[{") || text.includes("}]") || text.includes("done");
          if (isArray) {
            this.tasks = JSON.parse(text);
          } else {
            this.tasks = text.split("\n").filter(t => t != '').map((t) => {
              return { done: false, text: t, editing: false };
            });
          }
          this.text = "";
        } catch {
          this.tasks = [{ done: false, text: text, editing: false }];
          this.text = "";
        }
      } else {
        try {
          this.tasks = JSON.parse(text);
          this.text = this.tasks.map((t) => t.text).join("\n");
        } catch {
          this.tasks = [];
          this.text = text;
        }
      }
    },
    resize(height, width) {
      this.widgetHeight = height;
      this.widgetWidth = width;
    },
    showSettings() {
      this.modalSettings.show(this.id, this.getModel());
    },
    onSettingsSave(dto) {
      this.settingsModel = new WidgetSettings(dto);
      this.loadData();
    },
    removeWidget() {
      this.$emit("on-remove-widget", this.id);
    },
    clearTasks() {
      this.tasks = [];
      this.saveData();
    },
    clearCompletedTasks() {
      this.tasks = this.filters.active();
      this.saveData();
    },
    addTask() {
      const text = this.newTask.trim();
      if (text) {
        this.tasks.push({ done: false, text: text, editing: false });
        this.saveData();
        this.newTask = "";
      }
    },
    remove(i) {
      this.tasks.splice(i, 1);
      this.saveData();
    },
    doneEdit(e, i) {
      let text = e.target.value;
      if (!text) {
        this.remove(i);
      } else if (this.tasks[i].editing) {
        this.tasks[i].text = text;
        this.tasks[i].editing = false;
        this.saveData();
      }
    },
    editTask(i) {
      let elmentRef = `taskInput${i}`;
      this.tasks[i].editing = true;

      this.$nextTick(() => {
        if (this.$refs[elmentRef]) {
          this.$refs[elmentRef][0].$refs.input.focus();
        }
      });
    },
    getModel() {
      let model = this.settingsModel.toDto();
      if (this.settingsModel.checkBoxes) {
        model.Text = JSON.stringify(this.tasks);
      } else {
        model.Text = this.text;
      }
      return model;
    },
    saveData() {
      var widgetDto = {
        Id: this.id,
        WidgetID: WidgetType.Note,
        Settings: this.getModel(),
      };

      WidgetService.updateSettings(widgetDto);
    },
  },
};
</script>